const satisfactStatus = [
  {
    value: 0,
    label: '待评价'
  },
  {
    value: 1,
    label: '已评价'
  }
]
const satisfactResult = [
  {
    value: 5,
    label: '很满意'
  },
  {
    value: 4,
    label: '满意'
  },
  {
    value: 3,
    label: '一般'
  },
  {
    value: 2,
    label: '不满意'
  },
  {
    value: 1,
    label: '很不满意'
  }
]

const handleStatus = (ctxStatus, ctxConfig) => {
  return ctxConfig.find(item => item.value === ctxStatus)
}

const SatifactionColumns = [
  {
    title: '满意度ID',
    key: 'id',
    width: 80,
    dataIndex: 'id'
  },
  {
    title: '工单ID',
    key: 'workOrderList',
    dataIndex: 'workOrderList',
    width: 120,
    slots: {
      customRender: 'workOrderList'
    }
  },
  {
    title: '健管姓名',
    key: 'assistantNameList',
    width: 80,
    dataIndex: 'assistantNameList',
    slots: {
      customRender: 'assistantNameList'
    }
  },
  {
    title: '患者ID',
    key: 'ucPatientId',
    width: 80,
    dataIndex: 'ucPatientId'
  },
  {
    title: '患者姓名',
    key: 'patientName',
    width: 80,
    dataIndex: 'patientName'
  },
  {
    title: '评价状态',
    key: 'evaluateStatus',
    width: 80,
    customRender({ text }) {
      const { evaluateStatus } = text
      const { label } = handleStatus(evaluateStatus, satisfactStatus) || {}
      return label
    }
  },
  {
    title: '评价结果',
    key: 'evaluateResult',
    width: 80,
    customRender({ text }) {
      const { evaluateResult } = text
      const { label } = handleStatus(evaluateResult, satisfactResult) || {}
      return label
    }
  },
  {
    title: '创建时间',
    key: 'createdAt',
    width: 120,
    dataIndex: 'createdAt'
  },
  {
    title: '评价时间',
    key: 'evaluateTime',
    width: 120,
    dataIndex: 'evaluateTime',
    customRender({ record }) {
      const { evaluateStatus, evaluateTime } = record
      return evaluateStatus === 1 ? evaluateTime : '--'
    }
  }
]

export { satisfactStatus, satisfactResult, SatifactionColumns }
